if($('.upcoming-projects-slider').length) {

    // window.helpers.equalHeight($('section#careers-news-block .news-list-item .details-container'), 600);

    $(".upcoming-projects-slider").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });

}

if($('.careers-news-block').length) {

    window.helpers.equalHeight($('.careers-news-block .news-list-item .details-container'), 600);

}
